<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title class="text-h5">
        <span>{{ $t('entities.taxJurisdictions.entity') }}</span
        >:
        <span class="font-weight-bold">{{ taxJurisdictionName }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        type="list-item-two-line, divider, table-tbody" />
      <div v-else>
        <v-alert v-if="!hasTaxJurisdiction" type="info" class="mb-0">
          {{ $t('components.noData.noEntriesFound') }}
        </v-alert>
        <div v-else>
          <div class="text-subtitle-1 font-weight-bold mb-2 pl-1">
            {{ $t('entities.taxesV2.title') }}
          </div>
          <v-data-table
            :headers="headers"
            :items="taxes"
            :items-per-page="-1"
            :loading="isLoading"
            :loading-text="$t('components.noData.fetchingEntries')"
            hide-default-footer
            class="elevation-0">
            <template v-slot:item.rate="{ item }">
              <span class="font-weight-bold">{{ item.rate ?? '—' }}</span>
            </template>
            <template v-slot:no-data>
              <div class="py-6 text-center grey--text">
                {{ $t('components.noData.noEntriesFound') }}
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import TaxJurisdiction from '@/models/setup/TaxJurisdiction'

export default {
  name: 'Taxes',
  data() {
    return {
      isLoading: false,
      taxJurisdiction: null,
    }
  },
  computed: {
    arenaId() {
      return this.$store.getters.arena ? this.$store.getters.arena.id : null
    },
    hasTaxJurisdiction() {
      return !!this.taxJurisdiction?.id
    },
    headers() {
      return [
        { text: this.$t('entities.taxesV2.attributes.name'), value: 'name' },
        {
          text: this.$t('entities.taxesV2.attributes.invoiceLabel'),
          value: 'invoice_label',
        },
        {
          text: this.$t('entities.taxesV2.attributes.description'),
          value: 'description',
        },
        {
          text: this.$t('entities.taxesV2.attributes.rate'),
          value: 'rate',
          align: 'end',
        },
      ]
    },
    taxJurisdictionName() {
      return this.taxJurisdiction?.name || '—'
    },
    taxJurisdictionFiscalize() {
      const value = this.taxJurisdiction?.fiscalize
      if (typeof value === 'boolean') return value
      if (value === undefined || value === null || value === '') return '—'
      return value
    },
    taxes() {
      return this.taxJurisdiction?.taxes || []
    },
  },
  methods: {
    async fetchTaxJurisdiction() {
      if (!this.arenaId) {
        this.taxJurisdiction = null
        return
      }
      this.isLoading = true
      try {
        const response = await TaxJurisdiction.api.getArenaTaxJurisdiction(
          this.arenaId,
        )
        const payload = response?.data?.data || response?.data || {}
        this.taxJurisdiction = new TaxJurisdiction(payload)
      } catch (e) {
        console.error(e)
        this.taxJurisdiction = null
      } finally {
        this.isLoading = false
      }
    },
    refresh() {
      return this.fetchTaxJurisdiction()
    },
  },
  watch: {
    arenaId: {
      handler() {
        return this.fetchTaxJurisdiction()
      },
    },
  },
  async mounted() {
    await this.fetchTaxJurisdiction()
  },
}
</script>
